import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';

const ReactTableLoadingComponent = props =>
    !!props.loading && (
        <div className="react-table-loader">
            <LoadingSpinner isInline={true} text={props.loadingText} color="blue" />
        </div>
    );

export default ReactTableLoadingComponent;
